import Modal from "./modal";
import TransactionModal from "./transactionModal";
import AddCollaboratorModal from "./addCollaboratorModal";
import AddInvestmentModal from "./addInvestmentModal";
import AddPlanModal from "./addPlanModal";
import AddPoolModal from "./addPoolModal";
import CreateSimulationModal from "./createSimulationModal";
import ChangeDateModal from "./changeDateModal";
import ConvertAllConvertiblesModal from "./convertAllConvertiblesModal";
import ConvertibleLoanModal from "./convertibleLoanModal";
import DecreasePoolModal from "./decreasePoolModal";
import DecreaseSharesModal from "./decreaseSharesModal";
import ImportGrantsModal from "./importGrantsModal";
import ImportStakeholdersModal from "./importStakeholdersModal";
import IncorporationModal from "./incorporationModal";
import IncreasePoolModal from "./increasePoolModal";
import InviteCompanyModal from "./inviteCompanyModal";
import InviteStakeholderModal from "./inviteStakeholderModal";
import IssueModal from "./issueModal";
import PayoutModal from "./payoutModal";
import ShareClassModal from "./shareClassModal";
import ShareModal from "./shareModal";
import SingleGrantModal from "./singleGrantModal";
import SplitModal from "./splitModal";
import StakeholderModal from "./stakeholderModal";
import StartTrialModal from "./startTrialModal.js";
import TerminateGrantsModal from "./terminateGrantsModal";
import TransactionSelectionModal from "./transactionSelectionModal";
import TransferModal from "./transferModal";
import LoanModal from "./uloanModal";
import UploadDocumentModal from "./uploadDocumentModal";
import ValuationModal from "./valuationModal";
import "./stakeholderMultiEditModal";
import ConvertLoanModal from "./convertLoanModal";

window.Modal = Modal;
window.TransactionModal = TransactionModal;
window.AddCollaboratorModal = AddCollaboratorModal;
window.AddInvestmentModal = AddInvestmentModal;
window.AddPlanModal = AddPlanModal;
window.AddPoolModal = AddPoolModal;
window.CreateSimulationModal = CreateSimulationModal;
window.ChangeDateModal = ChangeDateModal;
window.ConvertAllConvertiblesModal = ConvertAllConvertiblesModal;
window.ConvertLoanModal = ConvertLoanModal;
window.ConvertibleLoanModal = ConvertibleLoanModal;
window.DecreasePoolModal = DecreasePoolModal;
window.DecreaseSharesModal = DecreaseSharesModal;
window.ImportGrantsModal = ImportGrantsModal;
window.ImportStakeholdersModal = ImportStakeholdersModal;
window.IncorporationModal = IncorporationModal;
window.IncreasePoolModal = IncreasePoolModal;
window.InviteCompanyModal = InviteCompanyModal;
window.InviteStakeholderModal = InviteStakeholderModal;
window.IssueModal = IssueModal;
window.PayoutModal = PayoutModal;
window.ShareClassModal = ShareClassModal;
window.ShareModal = ShareModal;
window.SingleGrantModal = SingleGrantModal;
window.SplitModal = SplitModal;
window.StakeholderModal = StakeholderModal;
window.StartTrialModal = StartTrialModal;
window.TerminateGrantsModal = TerminateGrantsModal;
window.TransactionSelectionModal = TransactionSelectionModal;
window.TransferModal = TransferModal;
window.LoanModal = LoanModal;
window.UploadDocumentModal = UploadDocumentModal;
window.ValuationModal = ValuationModal;
